import scrollbarHide from 'tailwind-scrollbar-hide';
import flowbiteReact from 'flowbite-react/plugin/tailwindcss';

export default {
   darkMode: 'class',
   content: [
      './src/**/*.{js,jsx,ts,tsx}',
      '.flowbite-react/class-list.json',
      './node_modules/flowbite-react/**/*.{js,jsx,ts,tsx}',
      './node_modules/flowbite/**/*.js',
      '.flowbite-react\\class-list.json',
   ],
   theme: {
      extend: {
         backgroundImage: {
            // Room card nightly-rate badge (admin create booking, Figma NPT-1454).
            'price-badge': 'linear-gradient(270deg, #FF8123 3.85%, #FFB463 50.96%, #FFB500 97.12%)',
         },
         colors: {
            primary: 'var(--color-primary)',
            lightPrimary: 'var(--color-light-primary)',
            secondary: 'var(--color-secondary)',
            callToAction: 'var(--color-call-to-action)',
            tertiary: 'var(--color-tertiary)',
            view: '#297242',
            border: '#E7E7E7',
            lightGray: '#F7F7F7',
            lightGreen: '#F3FFEC',
            hover: '#FAF5F0',
            twOrange: '#ED6837',
            twRed: '#E02424',
            twGreen: '#2E7D32',
            twGray: '#595959',
            checkbox: '#B9B9B9',
            borderStrong: '#8E8E8E',
            focusRing: '#1D4ED8',
            footer: '#0A1519',
            bgActive: '#EAF8FC',
            activeSidebar: '#4B7D81',
            footerSubtext: '#93B7BB',
            footerTicket: '#0B525B',
            footerBorder: '#D8EDF0',
            lPrimary: '#62A4AB',
            orgLightPrimary: 'var(--color-org-light-primary)',
            orgPrimary: 'var(--color-org-primary)',
            guideInk: 'var(--guide-ink, #0e2228)',
            guideDark: 'var(--guide-dark, #0b525b)',
            orgSecondary: 'var(--color-org-secondary)',
            orgView: 'var(--color-org-view)',
            orgLightView: 'var(--color-org-light-view)',
            orgCallToAction: 'var(--color-org-call-to-action)',
            orgHeaderText: 'var(--color-org-header-text)',
            orgHeroText: 'var(--color-org-hero-text)',
            orgStartBackground: 'var(--color-org-start-background)',
            orgEndBackground: 'var(--color-org-end-background)',
            positiveSecondary: '#CFF7D3',
            bgNavInteract: '#F4F8F9',
            primaryInteract: '#4B7D81',
         },
         spacing: {
            1.25: '0.313rem',
            1.75: '0.438rem',
            3.25: '0.813rem',
            3.75: '0.938rem',
            4.5: '1.125rem',
            5.5: '1.375rem',
            6.5: '1.625rem',
            7.5: '1.875rem',
            8.5: '2.125rem',
            9.5: '2.375rem',
            10.5: '2.625rem',
            11.5: '2.875rem',
            12.5: '3.125rem',
            13: '3.25rem',
            13.5: '3.375rem',
            14: '3.5rem',
            15: '3.75rem',
            18: '4.5rem',
            32: '8rem',
            xs: '0,9375rem',
            md: '1.875rem',
         },
         borderRadius: {
            6: '0.375rem',
            10: '0.625rem',
            15: '0.938rem',
         },
         fontSize: {
            /* Tight line-height variants (for compact UI: prices, badges, labels) */
            'l-2xs': ['0.625rem', { lineHeight: '0.625rem' }],
            'l-xs': ['0.75rem', { lineHeight: '0.75rem' }],
            'l-sm': ['0.875rem', { lineHeight: '0.875rem' }],
            'l-base': ['1rem', { lineHeight: '1rem' }],
            'l-lg': ['1.125rem', { lineHeight: '1.125rem' }],
            'l-xl': ['1.25rem', { lineHeight: '1.25rem' }],
            'l-1.5xl': ['1.375rem', { lineHeight: '1.375rem' }],
            'l-2xl': ['1.5rem', { lineHeight: '1.5rem' }],
            'l-2.1xl': ['1.625rem', { lineHeight: '1.625rem' }],
            'l-2.2xl': ['1.75rem', { lineHeight: '1.75rem' }],
            'l-3xl': ['1.875rem', { lineHeight: '1.875rem' }],
            'l-3.5xl': ['2rem', { lineHeight: '2rem' }],
            'l-4xl': ['2.25rem', { lineHeight: '2.25rem' }],
            'l-5xl': ['3rem', { lineHeight: '3rem' }],
            /* Standard line-height variants for intermediate sizes */
            '2xs': ['0.625rem', { lineHeight: '0.875rem' }],
            '1.5xl': ['1.375rem', { lineHeight: '1.75rem' }],
            '2.1xl': ['1.625rem', { lineHeight: '2rem' }],
            '2.2xl': ['1.75rem', { lineHeight: '2.25rem' }],
            '3.5xl': ['2rem', { lineHeight: '2.5rem' }],
         },
         lineHeight: {
            3: '0.75rem' /* 12px */,
            4: '1rem' /* 16px */,
            4.5: '1.125rem' /* 18px */,
            5: '1.25rem' /* 20px */,
            5.5: '1.375rem' /* 22px */,
            6: '1.5rem' /* 24px */,
            6.5: '1.625rem' /* 26px */,
            7: '1.75rem' /* 28px */,
            7.5: '1.875rem' /* 30px */,
            8: '2rem' /* 32px */,
            8.5: '2.125rem' /* 34px */,
            9: '2.25rem' /* 36px */,
            9.5: '2.375rem' /* 38px */,
            10: '2.5rem' /* 40px */,
            11.5: '2.875rem' /* 46px */,
            12: '3rem' /* 48px */,
            13.5: '3.375rem' /* 54px */,
            14: '3.5rem' /* 56px */,
            18: '4.5rem' /* 72px */,
         },
         boxShadow: {
            DEFAULT: '1px 1px 10px -1px rgba(0, 0, 0, 0.05)',
            md: '1px 1px 20px 0px #0000001F',
            sm: '1px 0px 10px 0px #00000033',
            tt: '0px 0px 15px 0px #0000004D',
            PRIMARY: '0px 0px 4px 2px rgba(133, 236, 247, 0.4)',
            scrollButton: '1px 1px 20px 0px rgba(0,0,0,0.1)',
            hoverScrollButton: '1px 1px 20px 0px rgba(0,0,0,0.2)',
            fm: '1px 1px 10px -1px #0000001A',
         },
         screens: {
            '2xs': '360px',
            xs: '420px',
            sm: '640px',
            md: '768px',
            lg: '1024px',
            xl: '1280px',
            '1.5xl': '1425px',
            '2xl': '1536px',
         },
         keyframes: {
            fadeIn: {
               '0%': { opacity: '0', transform: 'translateY(3px)' },
               '100%': { opacity: '1', transform: 'translateY(0)' },
            },
            marquee: {
               '0%': { transform: 'translateX(0)' },
               '100%': { transform: 'translateX(-50%)' },
            },
         },
         animation: {
            fadeIn: 'fadeIn 0.3s ease-out forwards',
            marquee: 'marquee var(--marquee-duration, 40s) linear infinite',
         },
         fontFamily: {
            bebas: ['"Bebas Neue"', 'sans-serif'],
         },
      },
   },

   plugins: [scrollbarHide, flowbiteReact],
};
